<template>
  <div class="corp-header">
    <div
      v-if="corporate?.logoFile"
      class="corp-logo"
    >
      <img
        :src="corporate.logoFile"
        alt="logo"
      />
    </div>
    <div
      v-else-if="corporate?.title"
      class="kds-typography-display-small"
    >
      {{ corporate.title }}
    </div>
  </div>
</template>

<script setup>
import useCorporateStore from '@shared/stores/useCorporateStore.js'
import { computed } from 'vue'

const corporateStore = useCorporateStore()

const props = defineProps({
  corporate: {
    type: Object,
    default: null,
  },
})

const corporate = computed(() => props.corporate || corporateStore.corporate)
</script>

<style lang="scss" scoped>
.corp-header {
  .corp-logo {
    img {
      max-height: 64px;
      max-width: 200px;

      @include media-up(md) {
        max-height: 80px;
        max-width: 272px;
      }
    }
  }
}
</style>
